export function categoryServerModel(category) {
    return {
        Name: category.name,
        Order: category.order,
        Enabled: category.enabled,
        Description: category.description,
        Applicable_channels: category.applicable_channels || [],
    };
}